import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Reserve() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Title */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-3">
              Reserve
            </h1>
            <p className="text-pink-500 text-xl">WEB予約</p>
            <p className="text-gray-600 mt-4">
              24時間いつでもご予約いただけます♡
            </p>
          </div>

          {/* Reservation Flow */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center">
              ご予約の流れ
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl font-bold text-white">1</span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  予約ページへ
                </h3>
                <p className="text-gray-600">
                  下記のボタンから外部予約ページへ移動します
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl font-bold text-white">2</span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  日時・コース選択
                </h3>
                <p className="text-gray-600">
                  ご希望の日時とコースをお選びください
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl font-bold text-white">3</span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  確認・詳細案内
                </h3>
                <p className="text-gray-600">
                  予約確定後、詳細をご案内いたします
                </p>
              </div>
            </div>
          </section>

          {/* Main CTA */}
          <section className="mb-16">
            <div className="bg-gradient-to-br from-pink-100 via-purple-100 to-pink-100 rounded-2xl p-12 text-center">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                ご予約はこちらから
              </h2>
              <p className="text-gray-700 mb-8 text-lg">
                外部予約サイトへ移動します
              </p>
              <a
                href="https://r.caskan.jp/jdspa"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-12 py-5 bg-gradient-to-r from-pink-500 to-pink-400 text-white text-xl rounded-full font-semibold hover:shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-check-line mr-3 text-2xl"></i>
                WEB予約へ進む
              </a>
            </div>
          </section>

          {/* Additional Buttons */}
          <section className="mb-16">
            <div className="grid md:grid-cols-2 gap-6">
              <a
                href="https://r.caskan.jp/jdspa"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white border-2 border-pink-300 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 text-center cursor-pointer group"
              >
                <i className="ri-calendar-line text-5xl text-pink-500 mb-4 group-hover:scale-110 transition-transform duration-300"></i>
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  初めてのご予約
                </h3>
                <p className="text-gray-600 mb-4">
                  初回の方はこちらから
                </p>
                <span className="text-pink-500 font-semibold">
                  予約する →
                </span>
              </a>

              <a
                href="https://r.caskan.jp/jdspa"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white border-2 border-pink-300 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 text-center cursor-pointer group"
              >
                <i className="ri-repeat-line text-5xl text-pink-500 mb-4 group-hover:scale-110 transition-transform duration-300"></i>
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  リピーターの方
                </h3>
                <p className="text-gray-600 mb-4">
                  2回目以降の方はこちら
                </p>
                <span className="text-pink-500 font-semibold">
                  予約する →
                </span>
              </a>
            </div>
          </section>

          {/* Notes */}
          <section className="mb-16">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center justify-center">
                <i className="ri-information-line text-pink-500 mr-3"></i>
                ご予約にあたって
              </h2>
              <div className="space-y-4 text-gray-700 max-w-3xl mx-auto">
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>ご予約は24時間受付しております。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>ご予約確定後、詳細な住所やアクセス方法をご案内いたします。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>キャンセルや変更の際は、お早めにご連絡をお願いいたします。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>ご不明な点がございましたら、お気軽にお問い合わせください♡</p>
                </div>
              </div>
            </div>
          </section>

          {/* Bottom CTA */}
          <div className="text-center">
            <a
              href="https://r.caskan.jp/jdspa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-12 py-5 bg-gradient-to-r from-pink-500 to-pink-400 text-white text-lg rounded-full font-semibold hover:shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-3 text-2xl"></i>
              予約ページを開く
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}